// import React from 'react'
// import ReactDOM from 'react-dom';
import { createFromIconfontCN } from '@ant-design/icons';
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2279020_6rk3qkap3uq.js'
})
export default IconFont
// ReactDOM.render(
//     <div className="icons-list">
//       <IconFont type="iconbiaoqing" />
//     </div>,
//     // eslint-disable-next-line no-undef
//     mountNode
//   );